import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import ContactForm from "./ContactForm";
import useInViewOnce from "../../hooks/useInViewOnce";

function Contact() {
  const { ref: heroRef, hasEntered: heroSeen } = useInViewOnce({ threshold: 0.18, once: true });
  const { ref: contentRef, hasEntered: contentSeen } = useInViewOnce({ threshold: 0.18, once: true });

  return (
    <Container fluid className="about-section contact-page">
      <Particle />

      <Container className="contact-container">
        <header ref={heroRef} className={`contact-hero contact-reveal${heroSeen ? " is-seen" : ""}`}>
          <h1 className="contact-hero-title">
            Let’s <strong className="purple">Collaborate</strong>
          </h1>
          <p className="contact-hero-lead">We’d love to hear from you. Send a message and we’ll get back to you soon.</p>
        </header>

        <section
          ref={contentRef}
          className={`contact-section contact-reveal${contentSeen ? " is-seen" : ""}`}
          aria-label="Contact form"
        >
          <Row className="contact-grid" style={{ justifyContent: "center" }}>
            <Col md={7} className="contact-col">
              <div className="policy-card contact-card contact-form-card">
                <h2 className="contact-card-title">Send us a message</h2>
                <p className="contact-card-lead">Tell us what you’re working on and how we can support you.</p>
                <ContactForm />
              </div>
            </Col>

            <Col md={5} className="contact-col">
              <div className="policy-card contact-card contact-info-card" aria-label="Contact details">
                <h2 className="contact-card-title">Contact</h2>
                <p className="contact-info-line">
                  <strong className="purple">Email:</strong> <a href="mailto:info@choicestfruit.com">info@choicestfruit.com</a>
                </p>
                <p className="contact-info-line">
                  <strong className="purple">Response time:</strong> Typically within 1–2 business days.
                </p>
                <div className="contact-note">
                  <p className="contact-note-text">
                    For partnerships, volunteering, or program questions, include the program name and the best way to reach you.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </section>
      </Container>
    </Container>
  )
}
export default Contact;
